const checkTenant = ({ detail: { oldUrl, newUrl, cancelNavigation } }) => {
    const { pathname } = new URL(newUrl);
    const sessionTenant = window.sessionStorage.getItem('authTenant');
    if (sessionTenant && pathname !== '/' && !pathname.includes('/#state=') && oldUrl === newUrl && !pathname.includes(sessionTenant)) {
        const target = pathname.split('/').splice(1)[0];
        const tenant = !!target ? target : sessionTenant;
        cancelNavigation();
        window.sessionStorage.setItem('authTenant', tenant);
        window.location.href = `/${tenant}`;
    }
};
window.addEventListener('single-spa:before-routing-event', checkTenant);